import ReactDOM from "react-dom";

function SendFilesModal(props: { id: string, handleSubmit: () => void, handleCancel: () => void }): JSX.Element {
    return ReactDOM.createPortal(
        <div id={props.id} className="modal fade" data-bs-backdrop="static" tabIndex={-1}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Attachments</h5>
                    </div>
                    <div className="modal-body overflow-auto" style={{ maxHeight: 320 }}>
                        <main></main>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn" onClick={props.handleCancel}>Cancel</button>
                        <button type="button" className="btn btn-secondary" id="submitBtn" onClick={props.handleSubmit}>Send</button>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
}

export interface _File extends File {
    blob?: string;
}
export function FileItem(props: { file: _File }) {
    return (
        <div className="card border rounded mb-3">
            <div className="row g-0">
                <div className="col-4">
                    {props.file.type.includes("image") ?
                        <img src={props.file.blob} className="img-fluid rounded-start h-100" /> :
                        <div className="p-4 rounded-start text-center bg-light h-100 d-flex align-items-center justify-content-center">
                            <i className="fa fa-paperclip fa-xl text-muted" aria-hidden="true"></i>
                        </div>
                    }
                </div>
                <div className="col-8">
                    <div className="card-body">
                        <p className="card-text text-muted">{props.file.name}</p>
                    </div>
                </div>
            </div>
        </div >
    );
}

export default SendFilesModal;
